export const ActionSetDonorDetails = ({ commit }, form) => {
  const donor_details = form;
  commit("SET_donor", donor_details);
};
